import React, { useState, useRef, useEffect } from 'react';
import { FiSend } from 'react-icons/fi';

interface ChatInputProps {
  onSend: (message: string) => void;
  disabled?: boolean;
}

const ChatInput: React.FC<ChatInputProps> = ({ onSend, disabled = false }) => {
  const [value, setValue] = useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = Math.min(textareaRef.current.scrollHeight, 120) + 'px';
    }
  }, [value]);

  const handleSend = () => {
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setValue('');
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-end',
        gap: '0.5rem',
        padding: '0.75rem 1rem',
        borderTop: '1px solid var(--color-border-light)',
        background: 'var(--color-surface)',
      }}
    >
      <textarea
        ref={textareaRef}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Posez votre question..."
        disabled={disabled}
        rows={1}
        style={{
          flex: 1,
          padding: '0.625rem 0.875rem',
          fontSize: 'var(--font-size-sm)',
          border: '1px solid var(--color-border)',
          borderRadius: 'var(--radius-lg)',
          background: 'var(--color-bg)',
          outline: 'none',
          resize: 'none',
          fontFamily: 'var(--font-family)',
          lineHeight: 1.5,
          maxHeight: 120,
          transition: 'border-color var(--transition-fast)',
        }}
        onFocus={(e) => {
          e.target.style.borderColor = 'var(--color-secondary)';
        }}
        onBlur={(e) => {
          e.target.style.borderColor = 'var(--color-border)';
        }}
      />
      <button
        onClick={handleSend}
        disabled={!value.trim() || disabled}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 36,
          height: 36,
          borderRadius: 'var(--radius-md)',
          background: value.trim() ? 'var(--color-primary)' : 'var(--color-border)',
          color: '#fff',
          transition: 'all var(--transition-fast)',
          flexShrink: 0,
          cursor: value.trim() ? 'pointer' : 'not-allowed',
        }}
      >
        <FiSend size={16} />
      </button>
    </div>
  );
};

export default ChatInput;
